<template>
   <div id="section-0" class="intro-container site-section" ref="introContainer">
      <div v-if="!this.$store.state.isPortrait" class="section-wrap">
         <Stage :class="{hidden: articlesEntered}">
            <div class="intro-video-wrapper">
               <video src="./../assets/video/intro_vid_800k.mp4" autoplay loop poster="./../assets/images/video-placeholder.jpg" ref="introVid"></video>
            </div>
         </Stage>
         <ScrollContent>
            <div class="intro adobe-clean" ref="intro">
               <div class="intro-headings-wrap" ref="introHeadingsWrap">
                  <svg class="adobe-logo" ref="adobeLogo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20" focusable="false">
                     <path fill="#FF0000" d="M15.1,0H24v20L15.1,0z M8.9,0H0v20L8.9,0z M12,7.4L17.6,20h-3.8l-1.6-4H8.1L12,7.4z"></path>
                  </svg>
                  <h1 class="intro-heading knockout-lite text-uppercase" ref="introHeading">
                     <span class="intro-heading-first" v-html="intro.headingFirst"></span>
                     <span class="intro-heading-second" v-html="intro.headingSecond"></span>
                  </h1>
                  <p class="intro-subheading text-uppercase" v-html="intro.subheading" ref="introSubheading"></p>
                  <LogoAnimation ref="logoAnimation"></LogoAnimation>
               </div>
               <ScrollPrompt ref="scrollPrompt"></ScrollPrompt>
               <div class="intro-text-wrap">
                  <div class="text-spacer" ref="textSpacer"></div>
                  <div class="intro-text" v-html="intro.paragraphText" ref="introText"></div>
               </div>
            </div>
         </ScrollContent>
      </div>
      <div v-else class="section-wrap">
         <div class="intro-video-wrapper">
            <video src="./../assets/video/intro_vid_800k.mp4" autoplay loop playsinline ref="introVid"></video>
         </div>
         <div class="intro adobe-clean" ref="intro">
            <div class="intro-headings-wrap" ref="introHeadingsWrap">
               <img class="adobe-logo" src="./../assets/images/logos/adobe.svg" ref="adobeLogo"/>
               <h1 class="intro-heading knockout-lite text-uppercase" ref="introHeading">
                  <span class="intro-heading-first" v-html="intro.headingFirst"></span>
                  <span class="intro-heading-second" v-html="intro.headingSecond"></span>
               </h1>
               <p class="intro-subheading text-uppercase" v-html="intro.subheading" ref="introSubheading"></p>
               <LogoAnimation ref="logoAnimation"></LogoAnimation>
               <ScrollPrompt ref="scrollPrompt"></ScrollPrompt>
            </div>
            <div class="intro-text-wrap">
               <div class="text-spacer" ref="textSpacer"></div>
               <div class="intro-text" v-html="intro.paragraphText" ref="introText"></div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import ScrollMagic from 'scrollmagic'
    import 'TweenMax'
    import 'TimelineMax'
    import 'animation.gsap'
    import 'debug.addIndicators'
    import {bus, smController, portraitIntroDuration} from '../consts'

    import content from './../content'

    import Stage from './Stage'
    import ScrollContent from './ScrollContent'
    import ScrollPrompt from './ScrollPrompt'
    import LogoAnimation from './LogoAnimation'

    export default {
        name: 'Intro',
        components: {
            Stage, ScrollContent, ScrollPrompt, LogoAnimation
        },
        data() {
            return {
                intro: content.intro,
                smController: new ScrollMagic.Controller(),
                introPinScene: new ScrollMagic.Scene(),
                introStartScene: new ScrollMagic.Scene()
            }
        },
        computed: {
            ...mapGetters({
                'articlesEntered': 'getArticlesEnteredState'
            })
        },
        methods: {
            setUpScenes() {

                // set up introStart animations
                let headingsTimeline = new TimelineMax();
                let adobeLogoTween = TweenMax.to(this.$refs.adobeLogo, 0.5, {scale: 0.9, y: window.innerHeight * -0.1});
                let headingTween = TweenMax.to(this.$refs.introHeading, 0.5, {scale: 0.9, y: window.innerHeight * -0.1 - 15});
                let subheadingTween = TweenMax.to(this.$refs.introSubheading, 0.5, {scale: 0.9, y: window.innerHeight * -0.1 - 30});
                let logosTween = TweenMax.to(this.$refs.logoAnimation.$el, 0.5, {y: 0, opacity: 0});
                let scrollPromptTween = TweenMax.to(this.$refs.scrollPrompt.$el, 0.5, {opacity: 0});
                let textTween = TweenMax.to([this.$refs.textSpacer, this.$refs.introText], 0.5, {opacity: 1, y: 0, delay: 0.3});
                headingsTimeline.add([adobeLogoTween, headingTween, subheadingTween, textTween, logosTween, scrollPromptTween]);

                // pin the intro content so it's no longer scrollable
                this.introPinScene
                    .triggerHook('onLeave')
                    .duration(window.innerHeight * .35)
                    .triggerElement(this.$refs.introContainer)
                    .setPin(this.$refs.introHeadingsWrap)
                    .addTo(this.smController)
                //.addIndicators({name: 'introPin'});

                this.introStartScene
                    .offset(50)
                    .setTween(headingsTimeline)
                    .addTo(this.smController)
                //.addIndicators({name: 'introStart'})
            },
        },
        mounted() {
            if (!this.$store.state.isPortrait && window.matchMedia('(min-width: 768px)').matches) {
                this.setUpScenes()
            }
            this.$el.classList.add('mounted');
            this.$emit('introMounted');

            this.$store.watch(
                (state) => {
                    return state.view;
                },
                (state) => {
                    if (state === 'intro') {
                        this.$refs.introVid.play();
                    } else {
                        this.$refs.introVid.pause();
                    }
                }
            );
        },
        beforeDestroy() {
            this.introPinScene.destroy();
            this.introStartScene.destroy();
            this.$refs.introVid.pause();
        }
    }
</script>

<style lang="scss" scoped>
   @import "../scss/_the-goods.scss";

   .intro-container {
      width    : 100%;
      position : relative;
      z-index  : 3;

      a {
         color : red !important;
      }
   }

   .att-stage {
      transition : transform .4s $default-bez;

      &.hidden {
         transform : translateY(100%);
      }

      img, video {
         object-fit : cover;
         width      : 100%;
         height     : 100%;
      }
   }

   .adobe-logo {
      width         : 4.5rem;
      max-height    : 4rem;
      margin-bottom : 1.2rem;

      @include screen-xs-sm {
         width : 2.5rem;
      }

      .landscape-mode & {

         @media screen and (max-height : 680px) and (min-width : $screen-md-min) {
            width : 3.7rem;
         }

         @include screen-xxl {
            width : 5rem;
         }
      }
   }

   h1 {
      font-size   : 7.4rem;
      line-height : 0.97;

      @include screen-xs-sm {
         font-size : 4rem;
      }

      @include screen-md {
         font-size     : 4.5rem;
         margin-bottom : 1.5rem;
      }

      @include screen-lg {
         font-size : 5.4rem;
      }

      @include screen-xxl {
         font-size : 8.4rem;
      }

      @media screen and (max-height : 680px) and (min-width : $screen-md-min) {
         .landscape-mode & {
            font-size : 6rem;
         }
      }

      .portrait-mode & {
         @include screen-md-lg-xl {
            font-size : 6rem;
         }
      }
   }

   .intro {
      padding   : 0 $scroll-content-padding-right 4rem $scroll-content-padding-left;
      margin    : 0 3rem;
      animation : fadein 2s;

      .portrait-mode & {

         @include screen-xs-sm {
            padding    : 30px 0 0 0;
            margin-top : 30px;
         }

         @include screen-md-lg-xl {
            padding : 5rem;
         }
      }

      .landscape-mode & {

         @include screen-xs-sm {
            padding : 4rem 0;
         }
      }

      @include screen-md {

         .landscape-mode & {
            padding-top : 0;
         }
      }

      &-heading, &-subheading, .adobe-logo {
         transform-origin : left;
      }

      &-headings-wrap {

         .landscape-mode & {
            max-width   : 500px;
            padding-top : 17vh;

            @include screen-md-lg-xl {
               float : left;
            }

            @media screen and (max-height : 680px) {
               padding-top : 12vh;
            }

            @media screen and (max-height : 580px) and (min-width : $screen-md-min) {
               padding-top : 5vh;
            }
         }
      }

      &-heading {
         transform     : scale(1.1);
         margin-bottom : 2rem;
      }

      &-heading-first {
         color : $color-accent;
      }

      &-subheading {
         font-size      : 1.5rem;
         line-height    : 1.4;
         letter-spacing : 0.4rem;
         transform      : scale(1.1);

         .landscape-mode & {

            @include screen-xs-sm {
               font-size : 1.2rem;
            }
         }

         @include screen-md {
            font-size      : 1.2rem;
            line-height    : 1.4;
            letter-spacing : 0.2rem;
         }

         @include screen-xs-sm {
            transform      : none;
            margin-bottom  : 1rem;
            font-size      : 1.3rem;
            line-height    : 2rem;
            letter-spacing : 0.26rem;
         }

         .portrait-mode & {
            @include screen-md-lg-xl {
               font-size : 1.5rem;
            }
         }
      }

      &-text-wrap {

         .landscape-mode & {
            @include screen-md-lg-xl {
               transform : translateY(-12vh);
            }
         }
      }

      .text-spacer {
         color      : $color-red;
         margin-top : 4rem;
      }

      .intro-text, .text-spacer {
         opacity   : 0;
         transform : translateY(30px);

         .landscape-mode & {

            @include screen-xs-sm {
               opacity   : 1;
               transform : translateY(0);
            }
         }
      }

      &-text {
         padding : 3rem 0 0 0;
      }
   }

   .intro-video-wrapper {
      animation           : fadein 2s;
      height              : 300px;
      overflow            : hidden;
      position            : relative;
      background-size     : cover;
      background-position : center;

      @include screen-md-lg {
         height : 40vh;
      }

      video {
         object-fit        : cover;
         position          : absolute;
         top               : 50%;
         left              : 50%;
         -webkit-transform : translateX(-50%) translateY(-50%);
         transform         : translateX(-50%) translateY(-50%);
         min-width         : 100%;
         min-height        : 100%;
         width             : 100%;
         height            : auto;
         overflow          : hidden;
      }
   }

   .portrait-mode {
      .intro-video-wrapper {
         height : 50vh;
      }

      .intro-container {
         position : relative;
      }

      .intro {
         &-headings-wrap {
            float : none;
         }

         &-heading {
            transform : none;
         }

         &-subheading {
            transform : none;

            @include screen-xs-sm {
               transform      : none;
               margin-bottom  : 1rem;
               font-size      : 1.3rem;
               line-height    : 2rem;
               letter-spacing : 0.26rem;
            }
         }

         .logo-animation {
            transform : none;
         }

         .intro-text, .text-spacer {
            opacity   : 1;
            transform : none;
         }

         &-text {
            margin-bottom : 100px;
         }
      }
   }

</style>

<style lang="scss">
   .intro-text {
      a {
         color           : #1975E5;
         text-decoration : none;
         transition      : color .3s;

         &:hover {
            color : #005abe;
         }
      }
   }
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue